export enum RangeMonthsOption {
  Zero = '0',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  Ten = '10',
  Eleven = '11',
}

export const RANGE_MONTHS_OPTIONS_ARRAY = Object.values(RangeMonthsOption);
